import z from 'zod'
import { asEnumType } from '@gqloom/zod'

export const Currency = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BGN: 'BGN',
  BHD: 'BHD',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BWP: 'BWP',
  BYR: 'BYR',
  BZD: 'BZD',
  CAD: 'CAD',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUP: 'CUP',
  CZK: 'CZK',
  DKK: 'DKK',
  DOP: 'DOP',
  EGP: 'EGP',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GGP: 'GGP',
  GHC: 'GHC',
  GIP: 'GIP',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JPY: 'JPY',
  KGS: 'KGS',
  KHR: 'KHR',
  KPW: 'KPW',
  KRW: 'KRW',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LTL: 'LTL',
  LVL: 'LVL',
  MKD: 'MKD',
  MNT: 'MNT',
  MUR: 'MUR',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SOS: 'SOS',
  SRD: 'SRD',
  SVC: 'SVC',
  SYP: 'SYP',
  THB: 'THB',
  TRL: 'TRL',
  TRY: 'TRY',
  TTD: 'TTD',
  TVD: 'TVD',
  TWD: 'TWD',
  UAH: 'UAH',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VEF: 'VEF',
  VND: 'VND',
  XCD: 'XCD',
  YER: 'YER',
  ZAR: 'ZAR',
  ZWD: 'ZWD',
} as const

export const currencyEnumSchema = z.enum(Currency).register(asEnumType, {
  name: 'Currency',
  description: 'Currency',
})

export type CurrencyKey = keyof typeof Currency
export type CurrencyValue = (typeof Currency)[keyof typeof Currency]
